export default "__VITE_ASSET__h76er1VE__"